import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import SharpStar from '../Icons/SharpStar'
import * as styles from '../RatingInput/_RatingInput.scss'
import PropTypes from 'prop-types';

const minimumTotalReviews = 5

class Rating extends React.Component {
  static propTypes = {
    numberOfStars: PropTypes.number,
    average: PropTypes.number,
    totalReviews: PropTypes.number,
    mobile: PropTypes.bool
  };

  render () {
    let numStars = 5
    if (this.props.numberOfStars > 0) {
      numStars = this.props.numberOfStars
    }
    let average = 0
    if (this.props.average > 0) {
      average = this.props.average
    }

    let stars = []
    for (let current = 1; current <= numStars; current++) {
      let half = false
      let full = true
      let noRating = false
      if (this.props.totalReviews > minimumTotalReviews) {
        if (current <= average) {
          full = true
        } else {
          let diff = current - average
          if (diff < 1) {
            if (diff > 0.25 && diff <= 0.75) {
              half = true
              full = true
            } else if (diff <= 0.25) {
              half = false
            } else {
              full = false
            }
          } else {
            full = false
          }
        }
      } else {
        full = false
        noRating = true
      }
      stars.push(!noRating ? <SharpStar key={current} className={styles['starDefault']} half={half} full={full} size={2} cursorChanges={false} /> : <SharpStar key={current} className={styles['star-no-rating']} half={half} full={full} size={2} cursorChanges={false} />)
    }

    return (
      <div>
        <div>
          {stars}
        </div>
        <div className={styles['pull-left']}>
          {this.props.totalReviews <= minimumTotalReviews ? 'Not enough client ratings' : this.props.totalReviews + ' client ratings'}
        </div>
      </div>
    )
  }
}

export default  (Rating)
